import { NavigateBackLink } from '@exam-center/components';
import { AdminExamRoomRequestInfoProvider } from '@exam-center/exam-location-management';
import { useParams } from '@exam-center/router';
import { Box, PageHeader } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ExamLocationManagementLayout() {
  const { roomRequestId } = useParams('/admin/exam-location/requests/:roomRequestId/physical-info');

  return (
    <>
      <PageHeader
        title='ข้อมูลลักษณะทางกายภาพ'
        linkAdornment={
          <NavigateBackLink
            to='/admin/exam-location/requests/:roomRequestId'
            params={{ roomRequestId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <AdminExamRoomRequestInfoProvider roomRequestId={roomRequestId}>
          <Outlet />
        </AdminExamRoomRequestInfoProvider>
      </Box>
    </>
  );
}
